import { Component, Input } from '@angular/core';

import { Browser } from '@capacitor/browser';

import { APP_STATE_KEYS, appDownloadUrl, appWebsiteUrl } from 'src/app/models';
import { DataUpdateRunner } from 'src/app/data/data-update-runner';
import { ActiveUserService } from 'src/app/services/active-user.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PlatformService } from 'src/app/services/platform.service';
import { StateService } from 'src/app/services/state.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'mea-header',
    templateUrl: 'header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
    @Input() pageTitle: string;

    isAuthenticated: Promise<boolean>;
    isAppUpdateAvailable: Promise<boolean>;
    isContentOutdated: Promise<boolean>;
    isVertical: boolean = false;

    constructor(
        public platformService: PlatformService,
        private authService: AuthenticationService,
        private stateService: StateService,
        private dataUpdateRunner: DataUpdateRunner,
        private activeUserService: ActiveUserService
    ) {
        this.isAuthenticated = this.authService.isAuthenticated();

        if (this.platformService.isNativeDevice) {
            this.isContentOutdated = this.stateService.get(APP_STATE_KEYS.DATA_IS_OUTDATED).then((value) => value === 'true');
            this.isAppUpdateAvailable = this.stateService.get(APP_STATE_KEYS.APP_IS_OUTDATED).then((value) => value === 'true');
            if(this.platformService.isLargeVertical){
                this.isVertical = true;
            }
        }
    }

    async updateApp() {
        Browser.open({ url: `https://${appWebsiteUrl[environment.name]}` });
    }

    async updateData() {
        await this.stateService.resetDataState();

        await this.dataUpdateRunner.next({
            userProfile: await this.activeUserService.userProfile(),
        });

        window.location.reload();
    }
}
